import React, { useEffect, useState } from 'react';
import { Checkbox, Form, Input, Select } from 'antd';
import { StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { FormLabel, FormWrap, MiniInputWrap } from 'pages/settings_page/style';
import { AntToggleButton, FormHeader, ModalFormContainer } from 'component/form_component/style';
import { useDispatch, useSelector } from 'react-redux';
import { createBranding, getBrandings } from 'redux/slices/brandingSlice';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { AllowedDomainListWrap, AllowedDomainWrap } from 'pages/brandings/style';
import { InputPatternRule, InputPatternRuleBrandingUrl } from 'utils/input_pattern';

export default function CreateBranding({ setModal }) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const CheckboxGroup = Checkbox.Group;
  const [checkAll, setCheckAll] = useState(false);
  const [checkedList, setCheckedList] = useState([]);
  const [isToggleChecked, setIsToggleChecked] = useState(false);
  const { themeData } = useSelector((state) => state.themes);
  const { domainFromApi } = useSelector((state) => state.domainData);

  const options = domainFromApi.map((domain) => `${domain.domainName}(${domain.fqdn})`);

  useEffect(() => {
    if (checkedList.length > 1) {
      form.setFieldsValue({ showDomains: true });
      setIsToggleChecked(true);
    } else {
      setIsToggleChecked(false);
    }
  }, [checkedList]);

  const onFinish = async (values) => {
    values.allowedDomains = checkedList;
    try {
      const response = await dispatch(createBranding(values));
      if (response?.payload.status === 200) {
        await SweetSweetAlert({ sweetData: response.payload.data.message, icon: 'success', buttonColor: 'green' });
        setModal(false);
        const { hostname, port } = window.location;
        const currentDomain = `${hostname}${port ? `:${port}` : ''}`;
        if (currentDomain === values.url) {
          window.location.reload(true);
        } else {
          dispatch(getBrandings());
        }
      } else if (response?.payload.data === 'Branding already assigned to this Url.') {
        SweetSweetAlert({ sweetData: response.payload.data, icon: 'error', buttonColor: 'red' });
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      return error;
    }
  };

  const onChange = (list) => {
    setCheckedList(list);
    setCheckAll(list.length === options.length);
  };

  const onCheckAllChange = (e) => {
    setCheckedList(e.target.checked ? options : []);
    setCheckAll(e.target.checked);
  };

  return (
    <ModalFormContainer className='af-modal-container af-add_branding-modal-container'>
      <FormHeader className='af-form-header af-add_branding-form-header'>Add Branding</FormHeader>
      <FormWrap className='af-form-wrap af-add_branding-form-wrap'>
        <Form
          className='af-form af-add_branding-form'
          form={form}
          onFinish={onFinish}
          name='create_branding'
          size='large'
          scrollToFirstError
          initialValues={{
            name: '',
            url: '',
            allowedDomains: checkedList,
            showDomains: false,
            themeId: null,
            forgotPassword: true,
            rememberMe: true,
          }}
        >
          <FormLabel
            name='name'
            label='Name'
            rules={[
              {
                required: true,
                message: 'Please Enter this Field',
              },
              {
                pattern: InputPatternRule.pattern,
                message: InputPatternRule.message,
              },
            ]}
            className='formItemEvenLine af-form-item af-add_branding-form-item af-add_branding-form-item-name'
          >
            <Input className='af-form-input af-add_branding-form-input af-add_branding-form-input_name' />
          </FormLabel>

          <FormLabel
            name='url'
            label='URL'
            rules={[
              {
                required: true,
                message: 'Please Enter this Field',
              },
              {
                pattern: InputPatternRuleBrandingUrl.pattern,
                message: InputPatternRuleBrandingUrl.message,
              },
            ]}
            className='formItemEvenLine af-form-item af-add_branding-form-item af-add_branding-form-item-url'
          >
            <Input
              className='af-form-input af-add_branding-form-input af-add_branding-form-input_url'
              placeholder='customer1.yourdomain.com'
            />
          </FormLabel>

          <FormLabel
            name='themeId'
            label='Theme'
            rules={[
              {
                required: true,
                message: 'Please Enter this Field',
              },
            ]}
            className='formItemEvenLine af-form-item af-add_branding-form-item af-add_branding-form-item-theme_id'
          >
            <Select
              placeholder='Select Theme'
              className='af-form-select af-add_branding-form-select af-add_branding-form-select_theme_id'
            >
              {themeData.map((theme) => (
                <Select.Option
                  className='af-form-select-option af-add_branding-form-select-option'
                  key={theme.id}
                  value={theme.id}
                >
                  {theme.themeName}
                </Select.Option>
              ))}
            </Select>
          </FormLabel>

          <FormLabel
            name='allowedDomains'
            label='Allowed Domains'
            className='formItemEvenLine af-form-item af-add_branding-form-item af-add_branding-form-item-allowed_domains'
            rules={[
              {
                required: true,
                message: 'Please Enter this Field',
              },
            ]}
          >
            <AllowedDomainWrap className='af-form-add_branding-allowed_domain-wrap'>
              <Checkbox
                className='af-form-checkbox af-form-checkbox-add_branding-allowed_domain'
                onChange={onCheckAllChange}
                checked={checkAll}
                indeterminate={checkedList.length > 0 && checkedList.length < options.length}
              >
                Select All
              </Checkbox>
              <AllowedDomainListWrap className='af-form-add_branding-allowed_domain-wrap-list'>
                <CheckboxGroup
                  className='af-form-checkbox af-form-checkbox-add_branding-allowed_domain'
                  options={options}
                  value={checkedList}
                  onChange={onChange}
                />
              </AllowedDomainListWrap>
            </AllowedDomainWrap>
          </FormLabel>

          <FormLabel
            name='showDomains'
            label='Show Domain Dropdown'
            valuePropName='checked'
            className='formItemEvenLine af-form-item af-add_branding-form-item af-add_branding-form-item-show_domains'
          >
            <AntToggleButton
              className='af-form-switch af-form-switch-add_branding-show_domain'
              disabled={isToggleChecked}
            />
          </FormLabel>
          <MiniInputWrap>
            <FormLabel
              name='forgotPassword'
              label='Forgot Password'
              valuePropName='checked'
              className='af-form-item af-add_branding-form-item af-add_branding-form-item-forgotPassword'
            >
              <AntToggleButton className='af-form-switch af-form-switch-add_branding-forgotPassword' />
            </FormLabel>
            <FormLabel
              name='rememberMe'
              label='Remember Me'
              valuePropName='checked'
              className='af-form-item af-add_branding-form-item af-add_branding-form-item-rememberMe'
            >
              <AntToggleButton className='af-form-switch af-form-switch-add_branding-rememberMe' />
            </FormLabel>
          </MiniInputWrap>

          <FormLabel
            style={{ textAlign: 'end' }}
            className='af-form-button-submit-wrapper af-add_branding-form-button-submit-wrapper'
          >
            <StyledButton
              type='primary'
              htmlType='submit'
              className='af-form-button af-add_branding-form-button af-add_branding-form-button_submit'
            >
              Add Branding
            </StyledButton>
          </FormLabel>
        </Form>
      </FormWrap>
    </ModalFormContainer>
  );
}
